import { Component, OnInit, inject } from '@angular/core';
import { SuggestionEngineService } from '../../../suggestion-engine/suggestion-engine.service';
import { ScoreCard } from '../../../models/suggestion-engine-models';

@Component({
  selector: 'app-scorecard',
  templateUrl: './scorecard.component.html',
  styleUrls: ['./scorecard.component.scss'],
  standalone: false,
})
export class ScorecardComponent implements OnInit {
  private ses = inject(SuggestionEngineService);

  scData: ScoreCard | null = null;
  state: string = 'loaded';

  ngOnInit() {
    this.ses.getScorecard().subscribe((x: { result: ScoreCard }) => {
      this.scData = x.result;
    });
  }
}
